import { useEffect, useState } from 'react';

export const useLoadingScreen = () => {
  const [isLoadingScreenVisible, setIsLoadingScreenVisible] = useState(true);

  useEffect(() => {
    const loadingScreen = document.getElementById('loading-screen');
    if (!loadingScreen) {
      return;
    }
    if (!isLoadingScreenVisible) {
      loadingScreen.style.display = 'none';
    } else {
      loadingScreen.style.display = 'visible';
    }
  }, [isLoadingScreenVisible]);

  return setIsLoadingScreenVisible;
};
